export enum DailyWeightType {
  MOT = 'MOT' as any,
  SUC = 'SUC' as any,
  PS = 'PS' as any,
  GP = 'GP' as any,
  FAT = 'FAT' as any,
}
